import "./index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import { ThemeProvider } from "./components/theme-provider";
import { Toaster } from "./components/ui/sonner";
import { AuthLayout } from "./pages/auth/_layout";
import { ForgotPasswordPage } from "./pages/auth/forgot-password";
import { LoginPage } from "./pages/auth/login";
import { ResetPasswordPage } from "./pages/auth/reset-password";
import { DashboardLayout } from "./pages/dashboard/_layout";
import { BadgesPage } from "./pages/dashboard/badges";
import { CountersPage } from "./pages/dashboard/counters";
import { EventsPage } from "./pages/dashboard/events";
import { FeatureFlagsPage } from "./pages/dashboard/feature-flags";
import { DashboardPage } from "./pages/dashboard/index";
import { LiveMapPage } from "./pages/dashboard/live-map";
import { UserSafetyPage } from "./pages/dashboard/user-safety";
import { UserCardsPage } from "./pages/dashboard/user_cards";
import { UsersPage } from "./pages/dashboard/users";
import { VehiclesPage } from "./pages/dashboard/vehicles";
import { useAuthStore } from "./stores/auth.store";

const queryClient = new QueryClient();

function NotFound() {
  const user = useAuthStore((s) => s.user);
  return <Navigate to={user ? "/dashboard" : "/auth"} replace />;
}

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </ThemeProvider>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/auth" replace />,
  },
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: <LoginPage />,
      },
      {
        path: "forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "reset-password",
        element: <ResetPasswordPage />,
      },
    ],
  },
  {
    path: "/dashboard",
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "live-map",
        element: <LiveMapPage />,
      },
      {
        path: "feature-flags",
        element: <FeatureFlagsPage />,
      },
      {
        path: "users",
        element: <UsersPage />,
      },
      {
        path: "events",
        element: <EventsPage />,
      },
      {
        path: "vehicles",
        element: <VehiclesPage />,
      },
      {
        path: "user-safety",
        element: <UserSafetyPage />,
      },
      {
        path: "profile-cards",
        element: <UserCardsPage />,
      },
      {
        path: "counters",
        element: <CountersPage />,
      },
      {
        path: "badges",
        element: <BadgesPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default App;
